import _ from 'lodash'
import {   
	FETCH_ACTIVE_SEASONS,
	SAVING_SEASON_RANKING,
	SAVE_SEASON_RANKINGPOINTS,
	RESET_RANKING_POINTS_SETTINGS,
	SET_RANKINGPOINTS_FILE,
	FETCH_SEASON_RANKING_POINTS,
	GETTING_SEASON_RANKING_POINTS
} from '../../actions'

function getSeasonDates(seasons){
	const seasonDates = []
	seasons.map(function(season) {
		const s = {
			id: season.id,
			description: season.description,
			isCurrent:season.isCurrent,
			isSeasonSet:season.isSeasonSet
		}
		seasonDates.push(s)
	})
	return seasonDates
}
function generateColumnsAndRows(rankingPoints)
{
  let row 			= 1
	let col 			= 1
	const cellWidth = 40
	const _columns = new Array()
	const _rows    = new Array()
	_columns.push (
	{
		key: 'fin',
		name: 'FIN',
		width:35
	}) 

	rankingPoints.map((cell) => {
		// create columns
		if(_.find(_columns, { key: cell.numberOfTeams }) == undefined) 
		{
			col = cell.numberOfTeams
			_columns.push (
			{
				key: col,
				name: col,
				width:cellWidth
			}) 
		}

		//  create rows
		if(_.find(_rows, { fin: cell.finish }) == undefined) 
		{
			row = new Object()
			row['fin'] = cell.finish
			_rows.push(row)
		}
		
		row[cell.numberOfTeams] = cell.points 
	})

	return {
		rows:_rows,
		columns:_columns
	} 
}

export default function seasonranking (state,action) {   
	const {  payload } = action      
	switch(action.type) {
		
		case FETCH_ACTIVE_SEASONS: 
		{           
			const { data } = payload
			if (data) {                
					const defaultId = payload.data[0].id
					const seasons = getSeasonDates(data)
					
					return Object.assign({},state,{
						values: {
							seasons,
							settingsseason:defaultId.toString(),
							tier:'1',
							noRankingPointsFound:false
						},
						fields: {
							seasons,
							settingsseason:defaultId.toString(),
							tier:'1',
							noRankingPointsFound:false
						}
					})
				}
				else {
						return state
				}
		}
		case SAVING_SEASON_RANKING:
		{
			const datasaved  = false 
			const savingdata = true
			return  { 
				...state, 
				values: 
				{
					...state.values,
					savingdata,
					datasaved         
				},
				fields: 
				{
					...state.fields,
					savingdata,
					datasaved
				}
			}
		}
		case GETTING_SEASON_RANKING_POINTS:
		{
		
			return  { 
				...state, 
				values: 
				{
					...state.values,
					gettingRankingPoints:true 
				},
				fields: 
				{
					...state.fields,
					gettingRankingPoints:true 
				}
			}
		}
		case SET_RANKINGPOINTS_FILE:
		{
			
			return  { 
				...state, 
				values: 
				{
					...state.values,
					rankingfilename:payload   
				},
				fields: 
				{
					...state.fields,
					rankingfilename:payload    
				}
			}
		}
		case SAVE_SEASON_RANKINGPOINTS:
		{
			const { data } = payload
			const rankingpoints = generateColumnsAndRows(data)
		
			return  { 
				...state, 
				values: 
				{
					...state.values,
					savingdata:false,
					datasaved:true,
					rankingpoints        
				},
				fields: 
				{
					...state.fields,
					savingdata:false,
					datasaved:true,
					rankingpoints
				}
			}
		}
		case FETCH_SEASON_RANKING_POINTS:
		{
			const { data } = payload
			console.log('FETCH_SEASON_RANKING_POINTS', data)
			const rankingpoints = data != undefined ? generateColumnsAndRows(data):{}
			const noRankingPointsFound = (data == undefined) ? true:false
			return  { 
				...state, 
				values: 
				{
					...state.values,
					gettingRankingPoints:false,
					rankingpoints,
					noRankingPointsFound        
				},
				fields: 
				{
					...state.fields,
					gettingRankingPoints:false,
					rankingpoints,
					noRankingPointsFound
				}
			}
		}
		case RESET_RANKING_POINTS_SETTINGS:
		{
			const reset = {
				savingdata:false,
				datasaved:false,
				rankingpoints:{},
				rankingfilename:'',
				noRankingPointsFound:false 
			}
			return  { 
				...state, 
				values: 
				{
					...state.values,
					...reset    
				},
				fields: 
				{
					...state.fields,
					...reset       
				}
			}
		}
		default: return state
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/forms/seasonranking.js